import CalendarView from './calendar-view';

export default CalendarView;
